import { OfferSyncResultModel } from './../../models/synchronization/offerSyncResultModel';
import { FileSystemType } from './../../common/enums';
import { FileSyncModel } from './../../models/synchronization/fileSyncModel';
import { OfferListModel } from './../../models/offer/offerListModel';
import { OfferFilterSettingsModel } from './../../models/offer/offerFilterSettingsModel';
import { OfferSyncModel } from './../../models/synchronization/offerSyncModel';
import { ProductLiteModel } from './../../models/product/productLiteModel';
import { GasInstallationModel } from './../../models/offerSteps/gasInstallationModel';
import { InstallationProductSyncModel } from './../../models/synchronization/installationProductSyncModel';
import { OfferInstallationSyncModel } from './../../models/synchronization/offerInstallationSyncDTO';
import { OfferGridModel } from './../../models/offer/offerGridModel';
import { OfferStepModel } from './../../models/offer/offerStepModel';
import { ClientDataModel } from './../../models/offerSteps/clientDataModel';
import { IClient, ILocation, IOffer } from './../../common/appDatabase';
import AppDatabase from "../../common/appDatabase";
import format from 'date-fns/format';
import AuthService from '../authService';
import { OfferStatus, OfferInstallationType, InstallationProductType, IsolationType } from '../../common/enums';
import { UserModel } from '../../models/user';
import { TwoDimPlanModel } from '../../models/offerSteps/twoDimPlanModel';
import { HeathInstallModel } from '../../models/offerSteps/heathInstallModel';
import { FileModel } from '../../models/fileModel';
import { fomatDateTimeAsString } from "../../common/functions/helperFunctions";

class LocalOffersService {
    db = new AppDatabase();
    authService = new AuthService();

    createOffer(offer: OfferStepModel) {
        let result = new Promise((resolve, reject) => {
            let newOfferId = 0;
            this.db.transaction('rw', this.db.clients, this.db.locations, this.db.offers, async () => {
                const { newClientId, newLocationId } = await this.processClientData(offer.clientData);
                let trader = new UserModel();
                trader.userId = this.authService.getUserId();
                trader.name = this.authService.getUserName();
                trader.phone = this.authService.getUserPhone();

                var offerToCreate: IOffer = {
                    remoteId: 0,
                    client: {
                        id: offer.clientData.clientId ? offer.clientData.clientId : newClientId,
                        name: offer.clientData ? offer.clientData.name : '',
                        email: offer.clientData ? offer.clientData.email : '',
                        phone: offer.clientData ? offer.clientData.phone : '',
                    },
                    clientEmail: offer.clientData ? offer.clientData.email : '',
                    clientId: offer.clientData.clientId ? offer.clientData.clientId : newClientId,
                    clientName: offer.clientData ? offer.clientData.name : '',
                    clientPhone: offer.clientData ? offer.clientData.phone : '',
                    date: offer.offerDate,
                    discount: offer.discount,
                    fixedDiscount: offer.fixedDiscount,
                    isActive: true,
                    location: {
                        id: offer.clientData.locationId ? offer.clientData.locationId : newLocationId,
                        address: offer.clientData ? offer.clientData.address : '',
                        clientId: offer.clientData.clientId ? offer.clientData.clientId : newClientId,
                        district: offer.clientData ? offer.clientData.disctrict : '',
                        municipality: offer.clientData ? offer.clientData.municipality : '',
                        town: offer.clientData ? offer.clientData.town : '',
                        latitude: offer.clientData ? offer.clientData.latitude : '',
                        longitude: offer.clientData ? offer.clientData.longitude : '',
                    },
                    locationAddress: offer.clientData ? offer.clientData.address : '',
                    locationDistrict: offer.clientData ? offer.clientData.disctrict : '',
                    locationId: offer.clientData.locationId ? offer.clientData.locationId : newLocationId,
                    locationMunicipality: offer.clientData ? offer.clientData.municipality : '',
                    locationTown: offer.clientData ? offer.clientData.town : '',
                    locationLatitude: offer.clientData ? offer.clientData.latitude : '',
                    locationLongitude: offer.clientData ? offer.clientData.longitude : '',
                    notes: '',
                    number: offer.offerNumber,
                    price: offer.price ? parseFloat(offer.price.toFixed(2)) : 0,
                    statusId: OfferStatus.NewOffer,
                    trader: trader,
                    traderId: this.authService.getUserId(),
                    isolationTypeId: offer.twoDimPlan.isolationType,
                    activeStep: offer.activeStep,
                    completedSteps: offer.completed.toString(),
                    disclaimer: offer.disclaimer,
                    adminNotes: offer.adminNotes,
                    isWithHeathInstall: offer.heathInstallCheck,
                    isWithWorkAndMaterials: offer.workAndMaterials,
                    planner: JSON.stringify(offer.planner),
                    roomHeight: offer.twoDimPlan.roomHeight,
                    reported: 0,
                    gasInstallation: new OfferInstallationSyncModel(),
                    heathInstallation: null,
                    files: new Array<FileSyncModel>(),
                    updatedOn: offer.updatedOn,
                    priceChanged: false,
                    remoteUpdatedOn: '',
                    statusHistory: offer.statusHistory,
                    equipmentOnly: offer.equipmentOnly,
                }

                if (offer.installationPdf) {
                    let installationFile = new FileSyncModel();

                    installationFile.content = offer.installationPdf.fileContent;
                    installationFile.fileSystemTypeId = FileSystemType.Installation;
                    installationFile.name = offer.installationPdf.fileName;
                    installationFile.sizeInBytes = offer.installationPdf.fileSizeInBytes;
                    installationFile.type = offer.installationPdf.fileType;
                    installationFile.updatedOn = offer.installationPdf.updatedOn;

                    offerToCreate.files.push(installationFile);
                }

                if (offer.offerPdf) {
                    let offerFile = new FileSyncModel();

                    offerFile.content = offer.offerPdf.fileContent;
                    offerFile.fileSystemTypeId = FileSystemType.Offer;
                    offerFile.name = offer.offerPdf.fileName;
                    offerFile.sizeInBytes = offer.offerPdf.fileSizeInBytes;
                    offerFile.type = offer.offerPdf.fileType;
                    offerFile.updatedOn = offer.offerPdf.updatedOn;

                    offerToCreate.files.push(offerFile);
                }

                if (offer.gasInstallation && offer.gasInstallation.axonometryPdf) {
                    let gasAxonometryFile = new FileSyncModel();

                    gasAxonometryFile.content = offer.gasInstallation.axonometryPdf.fileContent;
                    gasAxonometryFile.fileSystemTypeId = FileSystemType.AxonometricDiagramGas;
                    gasAxonometryFile.name = offer.gasInstallation.axonometryPdf.fileName;
                    gasAxonometryFile.sizeInBytes = offer.gasInstallation.axonometryPdf.fileSizeInBytes;
                    gasAxonometryFile.type = offer.gasInstallation.axonometryPdf.fileType;
                    gasAxonometryFile.updatedOn = offer.gasInstallation.axonometryPdf.updatedOn;

                    offerToCreate.files.push(gasAxonometryFile);
                }

                if (offer.heathInstall && offer.heathInstall.axonometryPdf) {
                    let heatAxonometryFile = new FileSyncModel();

                    heatAxonometryFile.content = offer.heathInstall.axonometryPdf.fileContent;
                    heatAxonometryFile.fileSystemTypeId = FileSystemType.AxonometricDiagramHeat;
                    heatAxonometryFile.name = offer.heathInstall.axonometryPdf.fileName;
                    heatAxonometryFile.sizeInBytes = offer.heathInstall.axonometryPdf.fileSizeInBytes;
                    heatAxonometryFile.type = offer.heathInstall.axonometryPdf.fileType;
                    heatAxonometryFile.updatedOn = offer.heathInstall.axonometryPdf.updatedOn;
                }

                if (offer.billOfQuantitiesExcel && offer.billOfQuantitiesExcel.fileContent) {
                    let billOfQuantites = new FileSyncModel();

                    billOfQuantites.content = offer.billOfQuantitiesExcel.fileContent;
                    billOfQuantites.fileSystemTypeId = FileSystemType.BillOfQuantities;
                    billOfQuantites.name = offer.billOfQuantitiesExcel.fileName;
                    billOfQuantites.sizeInBytes = offer.billOfQuantitiesExcel.fileSizeInBytes;
                    billOfQuantites.type = offer.billOfQuantitiesExcel.fileType;
                    billOfQuantites.updatedOn = offer.billOfQuantitiesExcel.updatedOn;

                    offerToCreate.files.push(billOfQuantites);
                }

                if (offer.billOfQuantitiesLaborExcel && offer.billOfQuantitiesLaborExcel.fileContent) {
                    let billOfQuantitesLabor = new FileSyncModel();

                    billOfQuantitesLabor.content = offer.billOfQuantitiesLaborExcel.fileContent;
                    billOfQuantitesLabor.fileSystemTypeId = FileSystemType.BillOfQuantitiesLabor;
                    billOfQuantitesLabor.name = offer.billOfQuantitiesLaborExcel.fileName;
                    billOfQuantitesLabor.sizeInBytes = offer.billOfQuantitiesLaborExcel.fileSizeInBytes;
                    billOfQuantitesLabor.type = offer.billOfQuantitiesLaborExcel.fileType;
                    billOfQuantitesLabor.updatedOn = offer.billOfQuantitiesLaborExcel.updatedOn;

                    offerToCreate.files.push(billOfQuantitesLabor);
                }

                let gasInstallation = new OfferInstallationSyncModel();
                gasInstallation.installationProducts = new Array<InstallationProductSyncModel>();
                gasInstallation.pipeInstallTypeId = offer.gasInstallation.pipeInstall ? offer.gasInstallation.pipeInstall : 1;
                gasInstallation.offerInstallationType = OfferInstallationType.Gas;
                gasInstallation.activeTab = offer.gasInstallation.activeTab;

                if (offer.gasInstallation.pipeInfo) {
                    gasInstallation.pipeInfo = JSON.stringify(offer.gasInstallation.pipeInfo);
                }

                if (offer.gasInstallation.fittings) {
                    gasInstallation.fittings = JSON.stringify(offer.gasInstallation.fittings);
                }


                if (offer.gasInstallation.products) {
                    for (let i = 0; i < offer.gasInstallation.products.length; i++) {
                        let currentProduct = offer.gasInstallation.products[i];

                        let product = new InstallationProductSyncModel();
                        product.productId = currentProduct.productId;
                        product.article = currentProduct.article;
                        product.articleNumber = currentProduct.articleNumber;
                        product.installationProductTypeId = InstallationProductType.Main;
                        product.price = currentProduct.price;
                        product.quantity = currentProduct.quantity;
                        product.billQuantity = currentProduct.billQuantity;
                        product.unitId = currentProduct.unitId;
                        product.addedFromPlanner = currentProduct.addedFromPlanner;
                        product.discount = currentProduct.discount;
                        product.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                        gasInstallation.installationProducts.push(product);
                    }
                }

                if (offer.gasInstallation.additionalProducts) {
                    for (let i = 0; i < offer.gasInstallation.additionalProducts.length; i++) {
                        let currentProduct = offer.gasInstallation.additionalProducts[i];

                        let product = new InstallationProductSyncModel();
                        product.productId = currentProduct.productId;
                        product.article = currentProduct.article;
                        product.articleNumber = currentProduct.articleNumber;
                        product.installationProductTypeId = InstallationProductType.Additional;
                        product.price = currentProduct.price;
                        product.quantity = currentProduct.quantity;
                        product.billQuantity = currentProduct.billQuantity;
                        product.unitId = currentProduct.unitId;
                        product.addedFromPlanner = currentProduct.addedFromPlanner;
                        product.discount = currentProduct.discount;
                        product.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                        gasInstallation.installationProducts.push(product);
                    }
                }

                offerToCreate.gasInstallation = gasInstallation;

                if (offer.heathInstallCheck && offer.heathInstall) {
                    let heathInstallation = new OfferInstallationSyncModel();
                    heathInstallation.installationProducts = new Array<InstallationProductSyncModel>();
                    heathInstallation.pipeInstallTypeId = offer.heathInstall.pipeInstall ? offer.heathInstall.pipeInstall : 1;
                    heathInstallation.offerInstallationType = OfferInstallationType.Heath;
                    heathInstallation.activeTab = offer.heathInstall.activeTab;

                    if (offer.heathInstall.pipeInfo) {
                        heathInstallation.pipeInfo = JSON.stringify(offer.heathInstall.pipeInfo);
                    }

                    if (offer.gasInstallation.fittings) {
                        heathInstallation.fittings = JSON.stringify(offer.gasInstallation.fittings);
                    }

                    if (offer.heathInstall.products) {
                        for (let i = 0; i < offer.heathInstall.products.length; i++) {
                            let currentProduct = offer.heathInstall.products[i];

                            let product = new InstallationProductSyncModel();
                            product.productId = currentProduct.productId;
                            product.article = currentProduct.article;
                            product.articleNumber = currentProduct.articleNumber;
                            product.installationProductTypeId = InstallationProductType.Main;
                            product.price = currentProduct.price;
                            product.quantity = currentProduct.quantity;
                            product.billQuantity = currentProduct.billQuantity;
                            product.unitId = currentProduct.unitId;
                            product.addedFromPlanner = currentProduct.addedFromPlanner;
                            product.discount = currentProduct.discount;
                            product.priceWithoutDiscount = currentProduct.priceWithoutDiscount;


                            heathInstallation.installationProducts.push(product);
                        }
                    }

                    if (offer.heathInstall.additionalProducts) {
                        for (let i = 0; i < offer.heathInstall.additionalProducts.length; i++) {
                            let currentProduct = offer.heathInstall.additionalProducts[i];

                            let product = new InstallationProductSyncModel();
                            product.productId = currentProduct.productId;
                            product.article = currentProduct.article;
                            product.articleNumber = currentProduct.articleNumber;
                            product.installationProductTypeId = InstallationProductType.Additional;
                            product.price = currentProduct.price;
                            product.quantity = currentProduct.quantity;
                            product.billQuantity = currentProduct.billQuantity;
                            product.unitId = currentProduct.unitId;
                            product.addedFromPlanner = currentProduct.addedFromPlanner;
                            product.discount = currentProduct.discount;
                            product.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                            heathInstallation.installationProducts.push(product);
                        }
                    }

                    offerToCreate.heathInstallation = heathInstallation;
                } else {
                    offerToCreate.heathInstallation = null;
                }

                newOfferId = await this.db.offers.add(offerToCreate);
            }).then(
                () => {
                    resolve(newOfferId);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get clients from local db');
            });
        });

        return result;
    }

    updateOffer(offer: OfferStepModel) {
        var result = new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.offers, this.db.clients, this.db.locations, async () => {
                await this.db.offers.get({ id: +offer.id }, async (dbOffer) => {
                    if (dbOffer) {
                        const { newClientId, newLocationId } = await this.processClientData(offer.clientData);

                        //dbOffer.remoteId = dbOffer.remoteId;

                        dbOffer.client = {
                            id: offer.clientData.clientId ? offer.clientData.clientId : newClientId,
                            name: offer.clientData ? offer.clientData.name : '',
                            email: offer.clientData ? offer.clientData.email : '',
                            phone: offer.clientData ? offer.clientData.phone : '',
                        };

                        dbOffer.clientEmail = offer.clientData ? offer.clientData.email : '';
                        dbOffer.clientId = offer.clientData.clientId ? offer.clientData.clientId : newClientId;
                        dbOffer.clientName = offer.clientData ? offer.clientData.name : '';
                        dbOffer.clientPhone = offer.clientData ? offer.clientData.phone : '';
                        dbOffer.discount = offer.discount;
                        dbOffer.fixedDiscount = offer.fixedDiscount;
                        //dbOffer.date = dbOffer.date;
                        //dbOffer.isActive = dbOffer.isActive;

                        dbOffer.location = {
                            id: offer.clientData.locationId ? offer.clientData.locationId : newLocationId,
                            address: offer.clientData ? offer.clientData.address : '',
                            clientId: offer.clientData.clientId ? offer.clientData.clientId : newClientId,
                            district: offer.clientData ? offer.clientData.disctrict : '',
                            municipality: offer.clientData ? offer.clientData.municipality : '',
                            town: offer.clientData ? offer.clientData.town : '',
                            latitude: offer.clientData ? offer.clientData.latitude : '',
                            longitude: offer.clientData ? offer.clientData.longitude : '',
                        }

                        dbOffer.locationAddress = offer.clientData ? offer.clientData.address : '';
                        dbOffer.locationDistrict = offer.clientData ? offer.clientData.disctrict : '';
                        dbOffer.locationId = offer.clientData.locationId ? offer.clientData.locationId : newLocationId;
                        dbOffer.locationMunicipality = offer.clientData ? offer.clientData.municipality : '';
                        dbOffer.locationTown = offer.clientData ? offer.clientData.town : '';
                        dbOffer.locationLatitude = offer.clientData ? offer.clientData.latitude : '';
                        dbOffer.locationLongitude = offer.clientData ? offer.clientData.longitude : '';
                        dbOffer.price = offer.price ? parseFloat(offer.price.toFixed(2)) : 0;
                        //dbOffer.notes = dbOffer.notes;
                        //dbOffer.number = dbOffer.number;
                        //dbOffer.trader = dbOffer.trader;
                        //dbOffer.traderId = dbOffer.traderId;
                        dbOffer.isolationTypeId = offer.twoDimPlan ? offer.twoDimPlan.isolationType : IsolationType.None;
                        dbOffer.roomHeight = offer.twoDimPlan ? offer.twoDimPlan.roomHeight : 0;
                        dbOffer.planner = JSON.stringify(offer.planner);
                        dbOffer.activeStep = offer.activeStep;
                        dbOffer.completedSteps = offer.completed.toString();
                        dbOffer.isWithHeathInstall = offer.heathInstallCheck;
                        dbOffer.isWithWorkAndMaterials = offer.workAndMaterials;
                        dbOffer.disclaimer = offer.disclaimer;
                        dbOffer.adminNotes = offer.adminNotes;
                        dbOffer.reported = 0;
                        dbOffer.statusId = offer.offerStatusId;
                        dbOffer.updatedOn = offer.updatedOn;
                        dbOffer.priceChanged = offer.priceChanged;
                        dbOffer.statusHistory = offer.statusHistory;
                        dbOffer.equipmentOnly = offer.equipmentOnly;

                        if (offer.gasInstallation) {
                            let gasInstallation = new OfferInstallationSyncModel();

                            if (dbOffer.gasInstallation) {
                                gasInstallation = dbOffer.gasInstallation;
                            }

                            gasInstallation.offerInstallationType = OfferInstallationType.Gas;

                            gasInstallation.pipeInstallTypeId = offer.gasInstallation.pipeInstall ? offer.gasInstallation.pipeInstall : 1;
                            gasInstallation.installationProducts = new Array<InstallationProductSyncModel>();
                            gasInstallation.activeTab = offer.gasInstallation.activeTab;

                            if (offer.gasInstallation.pipeInfo) {
                                gasInstallation.pipeInfo = JSON.stringify(offer.gasInstallation.pipeInfo);
                            }

                            if (offer.gasInstallation.fittings) {
                                gasInstallation.fittings = JSON.stringify(offer.gasInstallation.fittings);
                            }

                            if (offer.gasInstallation.products) {
                                for (let i = 0; i < offer.gasInstallation.products.length; i++) {
                                    let currentProduct = offer.gasInstallation.products[i];

                                    let installationProduct = new InstallationProductSyncModel();
                                    installationProduct.article = currentProduct.article;
                                    installationProduct.articleNumber = currentProduct.articleNumber;
                                    installationProduct.id = currentProduct.id;
                                    installationProduct.installationProductTypeId = InstallationProductType.Main;
                                    installationProduct.price = currentProduct.price;
                                    installationProduct.productId = currentProduct.productId;
                                    installationProduct.quantity = currentProduct.quantity;
                                    installationProduct.billQuantity = currentProduct.billQuantity ? currentProduct.billQuantity : currentProduct.quantity;
                                    installationProduct.unitId = currentProduct.unitId;
                                    installationProduct.addedFromPlanner = currentProduct.addedFromPlanner;
                                    installationProduct.discount = currentProduct.discount;
                                    installationProduct.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                                    gasInstallation.installationProducts.push(installationProduct);
                                }
                            }

                            if (offer.gasInstallation.additionalProducts) {
                                for (let i = 0; i < offer.gasInstallation.additionalProducts.length; i++) {
                                    let currentProduct = offer.gasInstallation.additionalProducts[i];

                                    let installationProduct = new InstallationProductSyncModel();
                                    installationProduct.article = currentProduct.article;
                                    installationProduct.articleNumber = currentProduct.articleNumber;
                                    installationProduct.id = currentProduct.id;
                                    installationProduct.installationProductTypeId = InstallationProductType.Additional;
                                    installationProduct.price = currentProduct.price;
                                    installationProduct.productId = currentProduct.productId;
                                    installationProduct.quantity = currentProduct.quantity;
                                    installationProduct.billQuantity = currentProduct.billQuantity ? currentProduct.billQuantity : currentProduct.quantity;
                                    installationProduct.unitId = currentProduct.unitId;
                                    installationProduct.addedFromPlanner = currentProduct.addedFromPlanner;
                                    installationProduct.discount = currentProduct.discount;
                                    installationProduct.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                                    gasInstallation.installationProducts.push(installationProduct);
                                }
                            }

                            dbOffer.gasInstallation = gasInstallation

                        }

                        if (offer.heathInstall && offer.heathInstallCheck) {
                            let heatInstallation = new OfferInstallationSyncModel();

                            if (dbOffer.heathInstallation) {
                                heatInstallation = dbOffer.heathInstallation;
                            }

                            heatInstallation.offerInstallationType = OfferInstallationType.Heath;

                            heatInstallation.pipeInstallTypeId = offer.heathInstall.pipeInstall ? offer.heathInstall.pipeInstall : 1;
                            heatInstallation.installationProducts = new Array<InstallationProductSyncModel>();
                            heatInstallation.activeTab = offer.heathInstall.activeTab;

                            if (offer.heathInstall.pipeInfo) {
                                heatInstallation.pipeInfo = JSON.stringify(offer.heathInstall.pipeInfo);
                            }

                            if (offer.heathInstall.fittings) {
                                heatInstallation.fittings = JSON.stringify(offer.heathInstall.fittings);
                            }

                            if (offer.heathInstall.products) {
                                for (let i = 0; i < offer.heathInstall.products.length; i++) {
                                    let currentProduct = offer.heathInstall.products[i];

                                    let installationProduct = new InstallationProductSyncModel();
                                    installationProduct.article = currentProduct.article;
                                    installationProduct.articleNumber = currentProduct.articleNumber;
                                    installationProduct.id = currentProduct.id;
                                    installationProduct.installationProductTypeId = InstallationProductType.Main;
                                    installationProduct.price = currentProduct.price;
                                    installationProduct.productId = currentProduct.productId;
                                    installationProduct.quantity = currentProduct.quantity;
                                    installationProduct.billQuantity = currentProduct.billQuantity ? currentProduct.billQuantity : currentProduct.quantity;
                                    installationProduct.unitId = currentProduct.unitId;
                                    installationProduct.addedFromPlanner = currentProduct.addedFromPlanner;
                                    installationProduct.discount = currentProduct.discount;
                                    installationProduct.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                                    heatInstallation.installationProducts.push(installationProduct);
                                }
                            }

                            if (offer.heathInstall.additionalProducts) {
                                for (let i = 0; i < offer.heathInstall.additionalProducts.length; i++) {
                                    let currentProduct = offer.heathInstall.additionalProducts[i];

                                    let installationProduct = new InstallationProductSyncModel();
                                    installationProduct.article = currentProduct.article;
                                    installationProduct.articleNumber = currentProduct.articleNumber;
                                    installationProduct.id = currentProduct.id;
                                    installationProduct.installationProductTypeId = InstallationProductType.Additional;
                                    installationProduct.price = currentProduct.price;
                                    installationProduct.productId = currentProduct.productId;
                                    installationProduct.quantity = currentProduct.quantity;
                                    installationProduct.billQuantity = currentProduct.billQuantity ? currentProduct.billQuantity : currentProduct.quantity;
                                    installationProduct.unitId = currentProduct.unitId;
                                    installationProduct.addedFromPlanner = currentProduct.addedFromPlanner;
                                    installationProduct.discount = currentProduct.discount;
                                    installationProduct.priceWithoutDiscount = currentProduct.priceWithoutDiscount;

                                    heatInstallation.installationProducts.push(installationProduct);
                                }
                            }

                            dbOffer.heathInstallation = heatInstallation;
                        } else {
                            dbOffer.heathInstallation = null;
                        }

                        if (offer.installationPdf) {
                            if (!dbOffer.files) {
                                dbOffer.files = new Array<FileSyncModel>();
                            }

                            let installationFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.Installation);
                            let isNew = false;

                            if (!installationFile) {
                                installationFile = new FileSyncModel();
                                isNew = true;
                            }

                            installationFile.content = offer.installationPdf.fileContent;
                            installationFile.fileSystemTypeId = FileSystemType.Installation;
                            installationFile.name = offer.installationPdf.fileName;
                            installationFile.sizeInBytes = offer.installationPdf.fileSizeInBytes;
                            installationFile.type = offer.installationPdf.fileType;
                            installationFile.updatedOn = offer.installationPdf.updatedOn;

                            if (isNew) {
                                dbOffer.files.push(installationFile);
                            }
                        }

                        if (offer.offerPdf) {
                            if (!dbOffer.files) {
                                dbOffer.files = new Array<FileSyncModel>();
                            }

                            let offerFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.Offer);
                            let isNew = false;

                            if (!offerFile) {
                                offerFile = new FileSyncModel();
                                isNew = true;
                            }

                            offerFile.content = offer.offerPdf.fileContent;
                            offerFile.fileSystemTypeId = FileSystemType.Offer;
                            offerFile.name = offer.offerPdf.fileName;
                            offerFile.sizeInBytes = offer.offerPdf.fileSizeInBytes;
                            offerFile.type = offer.offerPdf.fileType;
                            offerFile.updatedOn = offer.offerPdf.updatedOn;

                            if (isNew) {
                                dbOffer.files.push(offerFile);
                            }
                        }

                        if (offer.gasInstallation && offer.gasInstallation.axonometryPdf) {
                            if (!dbOffer.files) {
                                dbOffer.files = new Array<FileSyncModel>();
                            }

                            let gasAxonometryFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.AxonometricDiagramGas);
                            let isNew = false;

                            if (!gasAxonometryFile) {
                                gasAxonometryFile = new FileSyncModel();
                                isNew = true;
                            }

                            gasAxonometryFile.content = offer.gasInstallation.axonometryPdf.fileContent;
                            gasAxonometryFile.fileSystemTypeId = FileSystemType.AxonometricDiagramGas;
                            gasAxonometryFile.name = offer.gasInstallation.axonometryPdf.fileName;
                            gasAxonometryFile.sizeInBytes = offer.gasInstallation.axonometryPdf.fileSizeInBytes;
                            gasAxonometryFile.type = offer.gasInstallation.axonometryPdf.fileType;
                            gasAxonometryFile.updatedOn = offer.gasInstallation.axonometryPdf.updatedOn;

                            if (isNew) {
                                dbOffer.files.push(gasAxonometryFile);
                            }
                        }

                        if (offer.heathInstall && offer.heathInstall.axonometryPdf) {
                            if (!dbOffer.files) {
                                dbOffer.files = new Array<FileSyncModel>();
                            }

                            let heatAxonometryFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.AxonometricDiagramHeat);
                            let isNew = false;

                            if (!heatAxonometryFile) {
                                heatAxonometryFile = new FileSyncModel();
                                isNew = true;
                            }

                            heatAxonometryFile.content = offer.heathInstall.axonometryPdf.fileContent;
                            heatAxonometryFile.fileSystemTypeId = FileSystemType.AxonometricDiagramHeat;
                            heatAxonometryFile.name = offer.heathInstall.axonometryPdf.fileName;
                            heatAxonometryFile.sizeInBytes = offer.heathInstall.axonometryPdf.fileSizeInBytes;
                            heatAxonometryFile.type = offer.heathInstall.axonometryPdf.fileType;
                            heatAxonometryFile.updatedOn = offer.heathInstall.axonometryPdf.updatedOn;

                            if (isNew) {
                                dbOffer.files.push(heatAxonometryFile);
                            }
                        }

                        if (offer.billOfQuantitiesExcel && offer.billOfQuantitiesExcel.fileContent) {
                            if (!dbOffer.files) {
                                dbOffer.files = new Array<FileSyncModel>();
                            }

                            let billOfQuantitesFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.BillOfQuantities);
                            let isNew = false;

                            if (!billOfQuantitesFile) {
                                billOfQuantitesFile = new FileSyncModel();
                                isNew = true;
                            }

                            billOfQuantitesFile.content = offer.billOfQuantitiesExcel.fileContent;
                            billOfQuantitesFile.fileSystemTypeId = FileSystemType.BillOfQuantities;
                            billOfQuantitesFile.name = offer.billOfQuantitiesExcel.fileName;
                            billOfQuantitesFile.sizeInBytes = offer.billOfQuantitiesExcel.fileSizeInBytes;
                            billOfQuantitesFile.type = offer.billOfQuantitiesExcel.fileType;
                            billOfQuantitesFile.updatedOn = offer.billOfQuantitiesExcel.updatedOn;

                            if (isNew) {
                                dbOffer.files.push(billOfQuantitesFile);
                            }
                        } else {
                            if (dbOffer.files) {
                                let billOfQuantitesFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.BillOfQuantities);

                                if (billOfQuantitesFile) {
                                    const index = dbOffer.files.indexOf(billOfQuantitesFile);
                                    dbOffer.files.splice(index, 1);
                                }
                            }
                        }

                        if (offer.billOfQuantitiesLaborExcel && offer.billOfQuantitiesLaborExcel.fileContent) {
                            if (!dbOffer.files) {
                                dbOffer.files = new Array<FileSyncModel>();
                            }

                            let billOfQuantitesLaborFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor);
                            let isNew = false;

                            if (!billOfQuantitesLaborFile) {
                                billOfQuantitesLaborFile = new FileSyncModel();
                                isNew = true;
                            }

                            billOfQuantitesLaborFile.content = offer.billOfQuantitiesLaborExcel.fileContent;
                            billOfQuantitesLaborFile.fileSystemTypeId = FileSystemType.BillOfQuantitiesLabor;
                            billOfQuantitesLaborFile.name = offer.billOfQuantitiesLaborExcel.fileName;
                            billOfQuantitesLaborFile.sizeInBytes = offer.billOfQuantitiesLaborExcel.fileSizeInBytes;
                            billOfQuantitesLaborFile.type = offer.billOfQuantitiesLaborExcel.fileType;
                            billOfQuantitesLaborFile.updatedOn = offer.billOfQuantitiesLaborExcel.updatedOn;

                            if (isNew) {
                                dbOffer.files.push(billOfQuantitesLaborFile);
                            }
                        } else {
                            if (dbOffer.files) {
                                let billOfQuantitesLaborFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor);

                                if (billOfQuantitesLaborFile) {
                                    const index = dbOffer.files.indexOf(billOfQuantitesLaborFile);
                                    dbOffer.files.splice(index, 1);
                                }
                            }
                        }

                        await this.db.offers.update(+offer.id, dbOffer);
                    }
                });
            }).then(
                () => {
                    resolve(true)
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot edit offer in local db');
            });
        });

        return result;
    }

    getOffer(offerId: number) {
        var result = new Promise((resolve, reject) => {
            var offer = new OfferStepModel();
            this.db.transaction('r', this.db.clients, this.db.locations, this.db.offers, async () => {
                this.db.offers.get({ id: +offerId }, async (dbOffer) => {
                    if (dbOffer) {
                        offer.id = dbOffer.id || 0;

                        offer.clientData = new ClientDataModel();
                        offer.clientData.address = dbOffer.locationAddress;
                        offer.clientData.clientId = dbOffer.clientId;
                        offer.clientData.disctrict = dbOffer.locationDistrict;
                        offer.clientData.email = dbOffer.clientEmail;
                        offer.clientData.locationId = dbOffer.locationId;
                        offer.clientData.municipality = dbOffer.locationMunicipality;
                        offer.clientData.name = dbOffer.clientName;
                        offer.clientData.phone = dbOffer.clientPhone;
                        offer.clientData.town = dbOffer.locationTown;

                        offer.clientData.latitude = dbOffer.locationLatitude;
                        offer.clientData.longitude = dbOffer.locationLongitude;

                        offer.twoDimPlan = new TwoDimPlanModel();
                        offer.twoDimPlan.roomHeight = dbOffer.roomHeight;
                        offer.twoDimPlan.isolationType = dbOffer.isolationTypeId;

                        offer.offerNumber = dbOffer.number;
                        offer.offerDate = dbOffer.date;
                        offer.offerStatusId = dbOffer.statusId;
                        offer.planner = dbOffer.planner ? JSON.parse(dbOffer.planner) : '';
                        offer.activeStep = dbOffer.activeStep === 0 ? 1 : dbOffer.activeStep;
                        offer.completed = this.getCompletedSteps(dbOffer.completedSteps)
                        offer.heathInstallCheck = dbOffer.isWithHeathInstall;
                        offer.workAndMaterials = dbOffer.isWithWorkAndMaterials;
                        offer.disclaimer = dbOffer.disclaimer;
                        offer.adminNotes = dbOffer.adminNotes;
                        offer.price = dbOffer.price;
                        offer.discount = dbOffer.discount;
                        offer.fixedDiscount = dbOffer.fixedDiscount;
                        offer.reported = dbOffer.reported === 0 ? false : true;
                        offer.updatedOn = dbOffer.updatedOn;
                        offer.priceChanged = dbOffer.priceChanged;
                        offer.statusHistory = dbOffer.statusHistory;
                        offer.equipmentOnly = dbOffer.equipmentOnly;

                        if (dbOffer.trader && dbOffer.trader.userId) {
                            offer.trader = new UserModel();
                            offer.trader.userId = dbOffer.trader.userId;
                            offer.trader.name = dbOffer.trader.name;
                            offer.trader.phone = dbOffer.trader.phone;
                            offer.trader.email = dbOffer.trader.email;
                        }

                        offer.gasInstallation = new GasInstallationModel();

                        let gasInstallation = dbOffer.gasInstallation;
                        let heathInstallation = dbOffer.heathInstallation;

                        if (gasInstallation) {
                            offer.gasInstallation = new GasInstallationModel();
                            offer.gasInstallation.pipeInstall = gasInstallation.pipeInstallTypeId;
                            offer.gasInstallation.gasInstallWork = false;
                            offer.gasInstallation.activeTab = gasInstallation.activeTab ? gasInstallation.activeTab : 0;

                            if (gasInstallation.pipeInfo) {
                                offer.gasInstallation.pipeInfo = JSON.parse(gasInstallation.pipeInfo);
                            }

                            if (gasInstallation.fittings) {
                                offer.gasInstallation.fittings = JSON.parse(gasInstallation.fittings);
                            }

                            if (gasInstallation.installationProducts) {
                                for (let i = 0; i < gasInstallation.installationProducts.length; i++) {
                                    let currInstallproduct = gasInstallation.installationProducts[i]

                                    let productLite = new ProductLiteModel();
                                    productLite.article = currInstallproduct.article;
                                    productLite.articleNumber = currInstallproduct.articleNumber;
                                    productLite.id = currInstallproduct.id;
                                    productLite.price = currInstallproduct.price;
                                    productLite.productId = currInstallproduct.productId;
                                    productLite.quantity = currInstallproduct.quantity;
                                    productLite.billQuantity = currInstallproduct.billQuantity ? currInstallproduct.billQuantity : currInstallproduct.quantity;
                                    productLite.unitId = currInstallproduct.unitId;
                                    productLite.addedFromPlanner = currInstallproduct.addedFromPlanner;
                                    productLite.discount = currInstallproduct.discount;
                                    productLite.priceWithoutDiscount = currInstallproduct.priceWithoutDiscount;

                                    if (currInstallproduct.installationProductTypeId === InstallationProductType.Main) {
                                        if (!offer.gasInstallation.products) {
                                            offer.gasInstallation.products = new Array<ProductLiteModel>();
                                        }

                                        offer.gasInstallation.products.push(productLite);
                                    }

                                    if (currInstallproduct.installationProductTypeId === InstallationProductType.Additional) {
                                        if (!offer.gasInstallation.additionalProducts) {
                                            offer.gasInstallation.additionalProducts = new Array<ProductLiteModel>();
                                            offer.gasInstallation.gasInstallWork = true;
                                        }

                                        offer.gasInstallation.additionalProducts.push(productLite);
                                    }
                                }
                            }

                            if (heathInstallation) {
                                offer.heathInstall = new HeathInstallModel();
                                offer.heathInstall.pipeInstall = heathInstallation.pipeInstallTypeId;
                                offer.heathInstall.heathInstallWork = false;
                                offer.heathInstall.activeTab = heathInstallation.activeTab ? heathInstallation.activeTab : 0

                                if (heathInstallation.pipeInfo) {
                                    offer.heathInstall.pipeInfo = JSON.parse(heathInstallation.pipeInfo);
                                }

                                if (heathInstallation.fittings) {
                                    offer.heathInstall.fittings = JSON.parse(heathInstallation.fittings);
                                }

                                if (heathInstallation.installationProducts) {
                                    for (let i = 0; i < heathInstallation.installationProducts.length; i++) {
                                        let currInstallproduct = heathInstallation.installationProducts[i]

                                        let productLite = new ProductLiteModel();
                                        productLite.article = currInstallproduct.article;
                                        productLite.articleNumber = currInstallproduct.articleNumber;
                                        productLite.id = currInstallproduct.id;
                                        productLite.price = currInstallproduct.price;
                                        productLite.productId = currInstallproduct.productId;
                                        productLite.quantity = currInstallproduct.quantity;
                                        productLite.billQuantity = currInstallproduct.billQuantity ? currInstallproduct.billQuantity : currInstallproduct.quantity;
                                        productLite.unitId = currInstallproduct.unitId;
                                        productLite.addedFromPlanner = currInstallproduct.addedFromPlanner;
                                        productLite.discount = currInstallproduct.discount;
                                        productLite.priceWithoutDiscount = currInstallproduct.priceWithoutDiscount;

                                        if (currInstallproduct.installationProductTypeId === InstallationProductType.Main) {
                                            if (!offer.heathInstall.products) {
                                                offer.heathInstall.products = new Array<ProductLiteModel>();
                                            }

                                            offer.heathInstall.products.push(productLite);
                                        }

                                        if (currInstallproduct.installationProductTypeId === InstallationProductType.Additional) {
                                            if (!offer.heathInstall.additionalProducts) {
                                                offer.heathInstall.additionalProducts = new Array<ProductLiteModel>();
                                                offer.heathInstall.heathInstallWork = true;
                                            }

                                            offer.heathInstall.additionalProducts.push(productLite);
                                        }

                                    }
                                }
                            } else {
                                // We do this because of the pdf generation error when create pdfs for offers without heat installation
                                offer.heathInstall = new HeathInstallModel();
                                offer.heathInstall.products = new Array<ProductLiteModel>();
                                offer.heathInstall.additionalProducts = new Array<ProductLiteModel>();
                            }
                        }

                        if (dbOffer.files && dbOffer.files.length > 0) {
                            let installationFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.Installation);

                            if (installationFile) {
                                offer.installationPdf = new FileModel();
                                offer.installationPdf.fileContent = installationFile.content;
                                offer.installationPdf.fileName = installationFile.name;
                                offer.installationPdf.fileSizeInBytes = installationFile.sizeInBytes;
                                offer.installationPdf.fileType = installationFile.type;
                                offer.installationPdf.updatedOn = installationFile.updatedOn;
                            }

                            let offerFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.Offer);

                            if (offerFile) {
                                offer.offerPdf = new FileModel();
                                offer.offerPdf.fileContent = offerFile.content;
                                offer.offerPdf.fileName = offerFile.name;
                                offer.offerPdf.fileSizeInBytes = offerFile.sizeInBytes;
                                offer.offerPdf.fileType = offerFile.type;
                                offer.offerPdf.updatedOn = offerFile.updatedOn;
                            }

                            let gasAxonometryFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.AxonometricDiagramGas);

                            if (gasAxonometryFile) {
                                offer.gasInstallation.axonometryPdf = new FileModel();
                                offer.gasInstallation.axonometryPdf.fileContent = gasAxonometryFile.content;
                                offer.gasInstallation.axonometryPdf.fileName = gasAxonometryFile.name;
                                offer.gasInstallation.axonometryPdf.fileSizeInBytes = gasAxonometryFile.sizeInBytes;
                                offer.gasInstallation.axonometryPdf.fileType = gasAxonometryFile.type;
                                offer.gasInstallation.axonometryPdf.updatedOn = gasAxonometryFile.updatedOn;
                            }

                            let heatAxonometryFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.AxonometricDiagramHeat);

                            if (heatAxonometryFile && offer.heathInstall) {
                                offer.heathInstall.axonometryPdf = new FileModel();
                                offer.heathInstall.axonometryPdf.fileContent = heatAxonometryFile.content;
                                offer.heathInstall.axonometryPdf.fileName = heatAxonometryFile.name;
                                offer.heathInstall.axonometryPdf.fileSizeInBytes = heatAxonometryFile.sizeInBytes;
                                offer.heathInstall.axonometryPdf.fileType = heatAxonometryFile.type;
                                offer.heathInstall.axonometryPdf.updatedOn = heatAxonometryFile.updatedOn;
                            }

                            let billOfQuantitesFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.BillOfQuantities);

                            if (billOfQuantitesFile) {
                                offer.billOfQuantitiesExcel = new FileModel();
                                offer.billOfQuantitiesExcel.fileContent = billOfQuantitesFile.content;
                                offer.billOfQuantitiesExcel.fileName = billOfQuantitesFile.name;
                                offer.billOfQuantitiesExcel.fileSizeInBytes = billOfQuantitesFile.sizeInBytes;
                                offer.billOfQuantitiesExcel.fileType = billOfQuantitesFile.type;
                                offer.billOfQuantitiesExcel.updatedOn = billOfQuantitesFile.updatedOn;
                            }

                            let billOfQuantitesLaborFile = dbOffer.files.find(f => f.fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor);

                            if (billOfQuantitesLaborFile) {
                                offer.billOfQuantitiesLaborExcel = new FileModel();
                                offer.billOfQuantitiesLaborExcel.fileContent = billOfQuantitesLaborFile.content;
                                offer.billOfQuantitiesLaborExcel.fileName = billOfQuantitesLaborFile.name;
                                offer.billOfQuantitiesLaborExcel.fileSizeInBytes = billOfQuantitesLaborFile.sizeInBytes;
                                offer.billOfQuantitiesLaborExcel.fileType = billOfQuantitesLaborFile.type;
                                offer.billOfQuantitiesLaborExcel.updatedOn = billOfQuantitesLaborFile.updatedOn;
                            }
                        }
                    }
                });
            }).then(
                () => {
                    resolve(offer)
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get offer from local db');
            });

        });

        return result;
    }

    getOffers(from: number, numberOfRows: number, filterSettings: OfferFilterSettingsModel) {
        var result = new Promise((resolve, reject) => {
            let result = new OfferListModel();
            let count = 0;
            let notSentCount = 0;
            let offers = new Array<OfferGridModel>();
            this.db.transaction('r', this.db.offers, async () => {
                let dbOffers: any;

                if (filterSettings && (filterSettings.client || filterSettings.endDate || filterSettings.number || filterSettings.startDate || filterSettings.statusId)) {

                    let query = this.db.offers.orderBy('date');

                    if (filterSettings.client) {
                        query = query.filter((offer) => {
                            if (offer.clientName && offer.clientName.toLowerCase().includes(filterSettings.client.toLowerCase())) {
                                return true
                            }

                            return false;
                        })
                    }

                    if (filterSettings.number) {
                        query = query.filter((offer) => {
                            if (offer.number && offer.number.toLowerCase().includes(filterSettings.number.toLowerCase())) {
                                return true
                            }

                            return false;
                        })
                    }

                    if (filterSettings.statusId) {
                        query = query.filter((offer) => {
                            if (offer.statusId === filterSettings.statusId) {
                                return true
                            }

                            return false;
                        })
                    }

                    if (filterSettings.startDate && filterSettings.endDate) {
                        query = query.filter((offer) => {
                            let offerDate = new Date(offer.date);

                            let startDate = new Date(filterSettings.startDate);
                            startDate.setHours(0, 0, 0);

                            let endDate = new Date(filterSettings.endDate);
                            endDate.setHours(23, 59, 59);

                            if (offerDate.getTime() >= startDate.getTime() && offerDate.getTime() <= endDate.getTime()) {
                                return true;
                            }

                            return false
                        })
                    }

                    if (filterSettings.startDate && !filterSettings.endDate) {
                        query = query.filter((offer) => {
                            let offerDate = new Date(offer.date);

                            let startDate = new Date(filterSettings.startDate);
                            startDate.setHours(0, 0, 0);

                            if (offerDate >= startDate) {
                                return true
                            }

                            return false
                        })
                    }

                    if (!filterSettings.startDate && filterSettings.endDate) {
                        query = query.filter((offer) => {
                            let offerDate = new Date(offer.date);

                            let endDate = new Date(filterSettings.endDate);
                            endDate.setHours(23, 59, 59);

                            if (offerDate <= endDate) {
                                return true
                            }

                            return false
                        })
                    }

                    let notSentQuery = query.clone();
                    notSentCount = await notSentQuery.filter((offer) => {
                        if (!offer.remoteId) {
                            return true
                        }

                        return false;
                    }).count();

                    count = await query.count();
                    dbOffers = await query.reverse().offset(from).limit(numberOfRows).toArray();
                } else {
                    count = await this.db.offers.count();
                    dbOffers = await this.db.offers.orderBy('date').reverse().offset(from).limit(numberOfRows).toArray();
                }

                if (dbOffers) {
                    for (let i = 0; i < dbOffers.length; i++) {
                        let dbOffer = dbOffers[i];
                        let offer = new OfferGridModel();

                        offer.id = dbOffer.id!;
                        offer.remoteId = dbOffer.remoteId;
                        offer.clientAddress = dbOffer.locationAddress;
                        offer.clientName = dbOffer.clientName;
                        offer.clientTown = dbOffer.locationTown;
                        offer.offerDate = dbOffer.date;
                        offer.offerNumber = dbOffer.number;
                        offer.offerPrice = dbOffer.price;
                        offer.offerStatusId = dbOffer.statusId;
                        offer.traderName = dbOffer.trader ? dbOffer.trader.name : '';
                        offer.reported = dbOffer.reported === 1 ? true : false;
                        offer.priceChanged = dbOffer.priceChanged;

                        offers.push(offer);
                    }
                }

                result.count = count;
                result.notSentCount = notSentCount;
                result.offers = offers;

            }).then(
                () => {
                    resolve(result);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get offers from local db');
            });

        });

        return result;
    }

    updateOfferAfterSynchronization(syncOffer: OfferSyncModel) {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.offers, this.db.clients, this.db.locations, async () => {
                await this.db.offers.get({ id: +syncOffer.localId }, async (foundOffer) => {
                    if (foundOffer) {

                        let localClient = await this.db.clients.get({ id: syncOffer.clientLocalId });
                        let localLocation = await this.db.locations.get({ id: syncOffer.locationLocalId });

                        if (localClient) {
                            localClient.remoteId = syncOffer.clientId;
                            localClient.reported = 1;
                            await this.db.clients.update(localClient.id!, localClient);
                        }

                        if (localLocation) {
                            localLocation.remoteId = syncOffer.locationId;
                            localLocation.reported = 1;
                            await this.db.locations.update(localLocation.id!, localLocation);
                        }

                        foundOffer.remoteId = syncOffer.id;

                        foundOffer.clientId = localClient?.id!;
                        foundOffer.locationId = localLocation?.id!;

                        foundOffer.client = syncOffer.client;
                        foundOffer.clientEmail = syncOffer.clientEmail;
                        foundOffer.clientName = syncOffer.clientName;
                        foundOffer.clientPhone = syncOffer.clientPhone;
                        foundOffer.date = syncOffer.date;
                        foundOffer.discount = syncOffer.discount;
                        foundOffer.fixedDiscount = syncOffer.fixedDiscount;
                        foundOffer.isActive = syncOffer.isActive;
                        foundOffer.location = syncOffer.location;
                        foundOffer.locationAddress = syncOffer.locationAddress;
                        foundOffer.locationDistrict = syncOffer.locationDistrict;
                        foundOffer.locationMunicipality = syncOffer.locationMunicipality;
                        foundOffer.locationTown = syncOffer.locationTown;
                        foundOffer.locationLatitude = syncOffer.locationLatitude;
                        foundOffer.locationLongitude = syncOffer.locationLongitude;
                        foundOffer.notes = syncOffer.notes;
                        foundOffer.number = syncOffer.number;
                        foundOffer.price = syncOffer.price;
                        foundOffer.statusId = syncOffer.statusId;
                        foundOffer.trader = syncOffer.trader;
                        foundOffer.traderId = syncOffer.traderId;
                        foundOffer.isolationTypeId = syncOffer.isolationTypeId;
                        foundOffer.roomHeight = syncOffer.roomHeight;
                        foundOffer.planner = syncOffer.planner;
                        foundOffer.activeStep = syncOffer.activeStep;
                        foundOffer.completedSteps = syncOffer.completedSteps;
                        foundOffer.gasInstallation = syncOffer.gasInstallation;
                        foundOffer.heathInstallation = syncOffer.heathInstallation;
                        foundOffer.disclaimer = syncOffer.disclaimer;
                        foundOffer.adminNotes = syncOffer.adminNotes;
                        foundOffer.isWithHeathInstall = syncOffer.isWithHeathInstall;
                        foundOffer.isWithWorkAndMaterials = syncOffer.isWithWorkAndMaterials;
                        foundOffer.reported = 1;

                        if (syncOffer.files) {
                            syncOffer.files.forEach(file => {
                                file.updatedOn = this.getDate(file.updatedOn);
                            })
                        }

                        foundOffer.files = syncOffer.files;
                        foundOffer.updatedOn = this.getDate(syncOffer.updatedOn);
                        foundOffer.priceChanged = syncOffer.priceChanged;
                        foundOffer.remoteUpdatedOn = this.getDate(syncOffer.remoteUpdatedOn);
                        foundOffer.statusHistory = syncOffer.statusHistory;
                        foundOffer.equipmentOnly = syncOffer.equipmentOnly;
                        foundOffer.adminNotes = syncOffer.adminNotes;

                        await this.db.offers.update(parseInt(foundOffer.id!.toString()), foundOffer);

                    }
                })
            }).then(
                () => {
                    resolve(true);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot update offer after synchronization');
            });
        })
    }

    getOfferForSynchronization(offerId: number) {
        return new Promise((resolve, reject) => {
            let syncOffer: OfferSyncModel | null = new OfferSyncModel();

            this.db.transaction('r', this.db.offers, this.db.clients, this.db.locations, async () => {
                await this.db.offers.get(offerId, (dbOffer) => {
                    if (dbOffer) {
                        syncOffer = this.dbOfferToOfferSync(dbOffer);

                        this.db.clients.get(+dbOffer.clientId, (client) => {
                            if (client) {
                                syncOffer!.clientId = client.remoteId;
                                syncOffer!.client.id = client.remoteId;
                            } else {
                                syncOffer!.clientId = 0
                                syncOffer!.client.id = 0
                            }
                        });

                        this.db.locations.get(+dbOffer.locationId, (location) => {
                            if (location) {
                                syncOffer!.locationId = location.remoteId;
                                syncOffer!.location.id = location.remoteId;
                            } else {
                                syncOffer!.locationId = 0;
                                syncOffer!.location.id = 0;
                            }
                        });
                    } else {
                        syncOffer = null;
                    }
                });

            }).then(
                () => {
                    resolve(syncOffer);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get offers from local db');
            });
        })
    }

    getDeletedOffers = () => {
        return new Promise((resolve, reject) => {
            let offersToDelete = new Array<number>();

            this.db.transaction('r', this.db.deletedOffers, async () => {
                let deletedOffersFromDb = await this.db.deletedOffers.toArray();

                if (deletedOffersFromDb && deletedOffersFromDb.length > 0) {
                    for (let i = 0; i < deletedOffersFromDb.length; i++) {
                        offersToDelete.push(deletedOffersFromDb[i].remoteId);
                    }
                }
            }).then(
                () => {
                    resolve(offersToDelete);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get offers to delete from local db.');
            });
        })
    }

    clearDeletedOffers = () => {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.deletedOffers, async () => {
                await this.db.deletedOffers.clear();
            }).then(
                () => {
                    resolve(true)
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot clear deleted offers in local db.');
            });
        })
    }

    getOffersForSynchronization() {
        return new Promise((resolve, reject) => {
            let offersToReport = new Array<OfferSyncModel>();

            this.db.transaction('r', this.db.offers, this.db.clients, this.db.locations, async () => {
                await this.db.offers.where({ reported: 0 }).each(
                    (dbOffer) => {
                        let syncOffer = this.dbOfferToOfferSync(dbOffer);

                        this.db.clients.get(+dbOffer.clientId, (client) => {
                            if (client) {
                                syncOffer.clientId = client.remoteId;
                                syncOffer.client.id = client.remoteId;
                            } else {
                                syncOffer.clientId = 0
                                syncOffer.client.id = 0
                            }
                        });

                        this.db.locations.get(+dbOffer.locationId, (location) => {
                            if (location) {
                                syncOffer.locationId = location.remoteId;
                                syncOffer.location.id = location.remoteId;
                            } else {
                                syncOffer.locationId = 0;
                                syncOffer.location.id = 0;
                            }
                        });

                        offersToReport.push(syncOffer);
                    }
                );

            }).then(
                () => {
                    resolve(offersToReport);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get offers for synchronization from local db');
            });
        })
    }

    setOffersReported(offers: Array<OfferSyncModel>) {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.offers, this.db.clients, this.db.locations, async () => {
                if (offers && offers.length > 0) {
                    offers.forEach(offer => {
                        this.db.offers.get({ id: +offer.localId }, async (dbOffer) => {
                            if (dbOffer) {
                                dbOffer.reported = 1;
                                await this.db.offers.update(+offer.localId, dbOffer);

                                this.db.clients.get({ id: +dbOffer.clientId }, async (dbClient) => {
                                    if (dbClient) {
                                        dbClient.reported = 1;
                                        await this.db.clients.update(+dbOffer.clientId, dbClient);
                                    }
                                });

                                this.db.locations.get({ id: +dbOffer.locationId }, async (dbLocation) => {
                                    if (dbLocation) {
                                        dbLocation.reported = 1;
                                        await this.db.locations.update(+dbOffer.locationId, dbLocation);
                                    }
                                })
                            }
                        })
                    })
                }
            }).then(
                () => {
                    resolve(true);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot set offers as reported');
            });
        })
    }

    getOffersCount() {
        return new Promise((resolve, reject) => {
            let count = 0;
            this.db.transaction('r', this.db.offers, async () => {
                count = await this.db.offers.count();
            }).then(
                () => {
                    resolve(count)
                }
            ).catch(err => {
                console.log(err);
            });

        })
    }

    getOffersWithRemoteIdCount() {
        return new Promise((resolve, reject) => {
            let count = 0;
            this.db.transaction('r', this.db.offers, async () => {
                count = await this.db.offers.where("remoteId").notEqual(0).count();
            }).then(
                () => {
                    resolve(count)
                }
            ).catch(err => {
                reject(err);
            });

        })
    }

    getOffersWithNoRemoteIdCount() {
        return new Promise((resolve, reject) => {
            let count = 0;
            this.db.transaction('r', this.db.offers, async () => {
                count = await this.db.offers.where("remoteId").equals(0).count();
            }).then(
                () => {
                    resolve(count)
                }
            ).catch(err => {
                reject(err);
            });
        })
    }

    getOffersRemoteIds() {
        return new Promise((resolve, reject) => {
            let ids = new Array<number>(0);
            this.db.transaction('r', this.db.offers, async () => {
                this.db.offers.each(offer => {
                    if (offer.remoteId) {
                        ids.push(offer.remoteId)
                    }
                })
            }).then(
                () => {
                    resolve(ids)
                }
            ).catch(err => {
                reject(err);
            });
        })
    }

    addOffersToLocalDb(offers: Array<OfferSyncModel>) {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.offers, this.db.clients, this.db.locations, async () => {
                let offersForDb = new Array<IOffer>();
                offers.forEach(async (offer, index) => {
                    let dbOffer = this.offerToDbOffer(offer);

                    let localClient = await this.db.clients.get({ remoteId: offer.clientId });
                    let localLocation = await this.db.locations.get({ remoteId: offer.locationId });

                    if (localClient && localLocation) {
                        dbOffer.clientId = localClient?.id!;
                        dbOffer.locationId = localLocation?.id!;

                        offersForDb.push(dbOffer);
                    }

                    if (index + 1 === offers.length) {
                        await this.db.offers.bulkAdd(offersForDb);
                    }
                });
            }).then(
                () => {
                    resolve(true)
                }
            ).catch(err => {
                console.log(err);
            });
        })
    }

    deleteOffer(offerId: number) {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.offers, async () => {
                await this.db.offers.delete(+offerId);
            }).then(
                () => {
                    resolve(true)
                }
            ).catch(err => {
                console.log(err);
                reject("Problem deleting offer");
            });
        });
    }

    updateOffersRemoteIdentifiers(offersSyncResult: Array<OfferSyncResultModel>) {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.offers, async () => {
                if (offersSyncResult && offersSyncResult.length > 0) {
                    for (let i = 0; i < offersSyncResult.length; i++) {
                        await this.db.offers.get({ id: +offersSyncResult[i].localId }, async (dbOffer) => {
                            if (dbOffer) {
                                dbOffer.remoteId = +offersSyncResult[i].remoteId;
                                await this.db.offers.update(+offersSyncResult[i].localId, dbOffer);
                            }
                        })
                    }
                }
            }).then(
                () => {
                    resolve(true);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot set remote ids to newly created offers');
            });
        })
    }

    addOfferForDeletion = (remoteId: number) => {
        return new Promise((resolve, reject) => {
            this.db.transaction('rw', this.db.deletedOffers, async () => {
                var offerForDeletion = {
                    remoteId
                };
                await this.db.deletedOffers.add(offerForDeletion);
            }).then(
                () => {
                    resolve(true);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot add offer for deletion');
            });
        })
    }

    userHasNotSynchronizedOffers = () => {
        return new Promise((resolve, reject) => {
            let hasNotSynchronizedOffers = false;
            this.db.transaction('r', this.db.offers, async () => {
                let notReported = await this.db.offers.where({ reported: 0 }).toArray();

                if (notReported && notReported.length > 0) {
                    hasNotSynchronizedOffers = true
                }
            }).then(
                () => {
                    resolve(hasNotSynchronizedOffers);
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get user has not synchronized offers');
            });
        })
    }

    incrementServerOffersCount = () => {
        let count = 0;

        let offersCount = localStorage.getItem('offersCount');

        if (offersCount) {
            count += +offersCount + 1;
        } else {
            count = 1;
        }

        localStorage.setItem('offersCount', count.toString());
    }

    decrementServerOffersCount = () => {
        let count = 0;

        let offersCount = localStorage.getItem('offersCount');

        if (offersCount) {
            count += +offersCount - 1;
        }

        localStorage.setItem('offersCount', count.toString());
    }

    public generateOfferNumber = (): string => {
        let dateFormated = format(new Date(), 'ddMMyy-HHmm');
        let nameInitials = '';
        let userName = this.authService.getUserName();

        if (userName) {
            var userNameSplitted = userName.split(' ');
            if (userNameSplitted && userNameSplitted.length > 1) {
                nameInitials += userNameSplitted[0][0];
                nameInitials += userNameSplitted[1][0]
            }
        }

        return nameInitials + "-" + dateFormated;
    }

    private processClientData = async (clientData: ClientDataModel) => {
        let newClientId: any;
        let newLocationId: any;

        if (clientData) {
            // Process client
            if (!clientData.clientId) {
                newClientId = await this.createClient(clientData);
            } else {
                await this.updateClient(clientData);
            }

            // Process location
            if (!clientData.locationId) {
                let clientId = clientData.clientId ? clientData.clientId : newClientId;
                newLocationId = await this.createLocation(clientData, clientId);
            } else {
                await this.updateLocation(clientData);
            }
        }

        let result: ClientLocationCreate = {
            newClientId,
            newLocationId
        }

        return result;
    }

    private createClient = async (client: ClientDataModel) => {
        return new Promise(async (resolve, reject) => {
            let clientToAdd: IClient = {
                remoteId: 0,
                name: client.name,
                email: client.email,
                phone: client.phone,
                reported: 0
            }
            let result = await this.db.clients.add(clientToAdd);

            resolve(result);
        });
    }

    private updateClient = async (client: ClientDataModel) => {
        this.db.clients.get({ id: client.clientId }, async (foundClient) => {
            if (foundClient) {
                await this.db.clients.update(parseInt(foundClient.id!.toString()), {
                    id: foundClient.id,
                    remoteId: foundClient.remoteId,
                    name: client.name,
                    email: client.email,
                    phone: client.phone,
                    reported: foundClient.reported
                });
            }
        });
    }

    private createLocation = async (location: ClientDataModel, clientId: number) => {
        return new Promise(async (resolve, reject) => {
            let locationToAdd: ILocation = {
                remoteId: 0,
                address: location.address,
                clientId: clientId,
                municipality: location.municipality,
                town: location.town,
                district: location.disctrict,
                reported: 0,
                latitude: location.latitude,
                longitude: location.longitude,
            }

            let result = await this.db.locations.add(locationToAdd);

            resolve(result);
        });
    }

    private updateLocation = async (location: ClientDataModel) => {
        this.db.locations.get({ id: location.locationId }, async (foundLocation) => {
            if (foundLocation) {
                await this.db.locations.update(parseInt(foundLocation.id!.toString()), {
                    id: foundLocation.id,
                    remoteId: foundLocation.remoteId,
                    address: location.address,
                    clientId: location.clientId,
                    district: location.disctrict,
                    municipality: location.municipality,
                    town: location.town,
                    reported: foundLocation.reported,
                    latitude: location.latitude,
                    longitude: location.longitude,
                })
            }
        });
    }

    private getCompletedSteps(steps: string): Array<number> {
        let completedSteps = new Array<number>(0);

        if (steps) {
            let stepsSplitted = steps.split(',');
            if (stepsSplitted) {
                stepsSplitted.forEach(step => {
                    completedSteps.push(+step);
                })
            }
        }
        return completedSteps;
    }

    private dbOfferToOfferSync(offer: IOffer): OfferSyncModel {
        let offerSync = new OfferSyncModel();

        offerSync.id = offer.remoteId;
        offerSync.localId = offer.id!;
        offerSync.activeStep = offer.activeStep;
        offerSync.client = offer.client;
        offerSync.clientEmail = offer.clientEmail;
        //offerSync.clientId = offer.clientId;
        offerSync.clientLocalId = offer.clientId;
        offerSync.clientName = offer.clientName;
        offerSync.clientPhone = offer.clientPhone;
        offerSync.completedSteps = offer.completedSteps;
        offerSync.date = offer.date;
        offerSync.disclaimer = offer.disclaimer;
        offerSync.discount = offer.discount;
        offerSync.fixedDiscount = offer.fixedDiscount;
        offerSync.isActive = offer.isActive;
        offerSync.isWithHeathInstall = offer.isWithHeathInstall;
        offerSync.isWithWorkAndMaterials = offer.isWithWorkAndMaterials;
        offerSync.isolationTypeId = offer.isolationTypeId;
        offerSync.location = offer.location;
        offerSync.locationAddress = offer.locationAddress;
        offerSync.locationDistrict = offer.locationDistrict;
        //offerSync.locationId = offer.locationId;
        offerSync.locationLocalId = offer.locationId;
        offerSync.locationMunicipality = offer.locationMunicipality;
        offerSync.locationTown = offer.locationTown;
        offerSync.locationLatitude = offer.locationLatitude;
        offerSync.locationLongitude = offer.locationLongitude;
        offerSync.notes = offer.notes;
        offerSync.adminNotes = offer.adminNotes;
        offerSync.number = offer.number;
        offerSync.planner = offer.planner;
        offerSync.price = offer.price;
        offerSync.roomHeight = offer.roomHeight;
        offerSync.statusId = offer.statusId;
        offerSync.trader = offer.trader;
        offerSync.traderId = offer.traderId;
        offerSync.heathInstallation = offer.heathInstallation ? offer.heathInstallation : null;
        offerSync.gasInstallation = offer.gasInstallation;
        offerSync.files = offer.files;
        offerSync.updatedOn = offer.updatedOn;
        offerSync.remoteUpdatedOn = offer.remoteUpdatedOn;
        offerSync.equipmentOnly = offer.equipmentOnly;
        offerSync.statusHistory = offer.statusHistory;

        return offerSync;
    }

    private offerToDbOffer(offer: OfferSyncModel): IOffer {
        if (offer.files) {
            offer.files.forEach(file => {
                file.updatedOn = this.getDate(file.updatedOn);
            })
        }

        return {
            remoteId: offer.id,
            client: offer.client,
            clientEmail: offer.clientEmail,
            clientId: offer.clientId,
            clientName: offer.clientName,
            clientPhone: offer.clientPhone,
            date: offer.date,
            discount: offer.discount,
            fixedDiscount: offer.fixedDiscount,
            isActive: offer.isActive,
            location: offer.location,
            locationAddress: offer.locationAddress,
            locationDistrict: offer.locationDistrict,
            locationId: offer.locationId,
            locationMunicipality: offer.locationMunicipality,
            locationTown: offer.locationTown,
            locationLatitude: offer.locationLatitude,
            locationLongitude: offer.locationLongitude,
            notes: offer.notes,
            adminNotes: offer.adminNotes,
            number: offer.number,
            price: offer.price,
            statusId: offer.statusId,
            trader: offer.trader,
            traderId: offer.traderId,
            isolationTypeId: offer.isolationTypeId,
            activeStep: offer.activeStep,
            completedSteps: offer.completedSteps,
            disclaimer: offer.disclaimer,
            isWithHeathInstall: offer.isWithHeathInstall,
            isWithWorkAndMaterials: offer.isWithWorkAndMaterials,
            planner: offer.planner,
            roomHeight: offer.roomHeight,
            gasInstallation: offer.gasInstallation,
            heathInstallation: offer.heathInstallation,
            reported: 1,
            files: offer.files,
            updatedOn: this.getDate(offer.updatedOn),
            priceChanged: offer.priceChanged,
            remoteUpdatedOn: this.getDate(offer.remoteUpdatedOn),
            statusHistory: offer.statusHistory,
            equipmentOnly: offer.equipmentOnly,
        }
    }

    private getDate(value: string): string {
        if (value) {
            let dateStr = '';

            try {
                let date = new Date(value);
                dateStr = fomatDateTimeAsString(date);
            } catch (error) {
                console.log(error);
            }

            return dateStr;
        }

        return ''
    }
}

class ClientLocationCreate {
    newClientId: number;
    newLocationId: number;
}

export default LocalOffersService